var map = {
	"./Emoticon - 10@3x.png": 5145,
	"./Emoticon - 1@3x.png": 7652,
	"./Emoticon - 2@3x.png": 535,
	"./Emoticon - 3@3x.png": 3138,
	"./Emoticon - 4@3x.png": 8995,
	"./Emoticon - 5@3x.png": 8736,
	"./Emoticon - 6@2x.png": 6917,
	"./Emoticon - 7@3x.png": 7963,
	"./Emoticon - 8@3x.png": 1230,
	"./Emoticon - 9@3x.png": 1187
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4027;